import { Component, Input, OnInit } from '@angular/core';
import { BadgeOptions, badgeColorCode } from 'app/components/badge/badge.interface';
import { DateTimePipe } from 'app/core/pipes/datetimeformator.pipe';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { MapsService } from 'app/modules/maps/maps.service';
import _ from 'lodash';
import moment from 'moment';
import { DispatchBoardService } from '../../../../../../../projects/dispatch-board/src/app/components/dispatch-board/dispatch-board.service';


@Component({
  selector: 'app-job-popup',
  templateUrl: './job-popup.component.html',
  styleUrls: ['./job-popup.component.scss']
})
export class JobPopupComponent implements OnInit {
  @Input() data: any;
  @Input() showAssignedEmployees?: boolean = true;
  @Input() timezone?: string = moment.tz.guess();
  jobTitle: string = '';
  dateTimeFormat = this.utilityService.dateTimeFormat;

  constructor(
    private _localisationService: LocalisationService,
    private _mapService: MapsService,
    private utilityService: UtilityService,
    private dispatchBoardService: DispatchBoardService
  ) { }

  openJobPopup(data?: any, canEdit?: boolean): void {
    const previewData = {
      'uid' : data.job_uid,
      'module' : 'JOB',
    };
    if(canEdit){
      previewData['canEdit'] = canEdit;
    }
    this._mapService.previewUid.next(previewData);
  }

  getJobStatusOptions(status: any): BadgeOptions {
    const badgeOption: BadgeOptions = {
      type: status?.status_name,
      color: status?.status_color || badgeColorCode[status?.status_type],
      displayName: status?.status_name,
      extraClass: 'capitalize'
    };
    return badgeOption;
  }

  getJobPriorityBadgeOptions(job): BadgeOptions{
    const priority  = job.job_priority.charAt(0)+(job.job_priority.toLowerCase().split('').splice(1).join(''));
    if(job?.job_priority){
      return {
        type: job.job_priority,
        displayKey: null,
        displayName: priority
      };
    }
  }

  ngOnInit(): void {
    this._localisationService.setDefaultLanguage();
    this.jobTitle = this._mapService.getJobTitle(this.data);
  }

}
